import React from 'react';
// import Configurer from '../../components/Configurer';
// import { checkTextTranslation } from '../../utils/useful'
import Kanban from '../Kanban';


export default class Kanbanview extends React.Component {

    state = {

    }




    render() {

        // console.log(this.props.stackedKey)
        return (
            <>
                <Kanban
                    data={this.props.data}
                    changeValue={this.props.changeValue}
                    actions={this.props.actions}
                    width={this.props.width}
                    headers={this.props.headers}
                    stackedKey={this.props.stackedKey}
                    view={this.props.view}
                    page={this.props.page}
                    functionsHandler={this.props.functionsHandler}
                    openSelectStack={this.props.openSelectStack}

                    isLoading={this.props.isLoadingData}
                    setCurrentHead={this.props.setCurrentHead}
                    setData={this.props.setData}
                    currentHead={this.props.currentHead}
                    initData={this.props.initData}
                    variables={this.props.variables}
                    hideHeaderField={this.props.hideHeaderField}
                    deleteHeaderField={this.props.deleteHeaderField}
                    limit={this.props.limit}
                    currentPage={this.props.currentPage}
                    totalCount={this.props.totalCount}
                    changePage={this.props.changePage}
                    currentRecord={this.props.currentRecord}
                    currentRecordStage={this.props.currentRecordStage}
                    changeRecordStage={this.props.changeRecordStage}
                    setCurrentRecordStage={this.props.setCurrentRecordStage}
                    colors={this.props.colors}
                    params={this.props.params}
                    submitForm={this.props.submitForm}
                />
            </>
        )
    }
}